'use client'

import { useTranslations } from 'next-intl'
import Section from '@/kmsApp/components/layout/section'
import Button from '@/kmsApp/components/shared/ui/button'
import { Control, FieldArrayWithId, FieldErrors, UseFormRegister, useWatch } from 'react-hook-form'
import { CourseForm as CourseFormType } from '@/kmsApp/types/forms/course-form'
import { StopItem } from './StopItem'
import { AdresseFavorite } from '@/kmsApp/types/models/adresse-favorite'
import { CourseTarifFixeSection } from '@/kmsApp/components/features/course/course-tarif-fixe-section'
import { TarifFixeCourse } from '@/kmsApp/types/models/tarif-fixe-course'
import { InfoTransportArretForm } from '@/kmsApp/types/forms/tarif-fixe-course-form'
import { CourseDatesFields } from './CourseDatesFields'

interface Props {
  fields: FieldArrayWithId<CourseFormType, 'arrets', 'id'>[]
  control: Control<CourseFormType>
  register: UseFormRegister<CourseFormType>
  errors: FieldErrors<CourseFormType>
  getLabelAndIconFromOrdre: (ordre: number) => {
    labelOrdre: string
    iconOrdre: string
  }
  currentStep: number
  openAddressSearch: (index: number) => void
  onNext: () => void
  isEscale: (ordre: number) => boolean
  addEscale: () => void
  removeEscale: (indexToRemove: number) => void
  openFavoriteDrawer?: ((index: number) => void) | null
  favorites?: AdresseFavorite[]
  /** Tarifs négociés réservables. Vide pour un visiteur anonyme. */
  tarifsFixes?: TarifFixeCourse[]
  tarifsFixesLoading?: boolean
  tarifFixeSelectionne?: TarifFixeCourse | null
  onTarifFixeChange?: (idTarifFixe: number | null) => void
  infosTransport?: InfoTransportArretForm[]
  onInfosTransportChange?: (infos: InfoTransportArretForm[]) => void
}

export const StopInformation = ({
  fields,
  control,
  register,
  errors,
  getLabelAndIconFromOrdre,
  currentStep,
  openAddressSearch,
  onNext,
  isEscale,
  addEscale,
  removeEscale,
  openFavoriteDrawer,
  favorites,
  tarifsFixes = [],
  tarifsFixesLoading = false,
  tarifFixeSelectionne = null,
  onTarifFixeChange,
  infosTransport = [],
  onInfosTransportChange,
}: Props) => {
  const t = useTranslations('web_course_form')
  const dateCourse = useWatch({ control, name: `dateCourse` })
  const trajetretour = useWatch({ control, name: `avecTrajetRetour` })
  const dateTrajetRetour = useWatch({ control, name: `dateTrajetRetour` })

  if (currentStep !== 1) return null

  return (
    <Section titre={t('trip_configuration')} icon="map">
      {/* Un trajet préconfiguré remplace la saisie d'itinéraire : son trajet et
          son prix sont convenus, il n'y a plus rien à composer ici. */}
      {onTarifFixeChange && onInfosTransportChange && (
        <CourseTarifFixeSection
          tarifsFixes={tarifsFixes}
          isLoading={tarifsFixesLoading}
          tarifFixeSelectionne={tarifFixeSelectionne}
          onSelectionChange={onTarifFixeChange}
          infosTransport={infosTransport}
          onInfosTransportChange={onInfosTransportChange}
        />
      )}

      {tarifFixeSelectionne && (
        <CourseDatesFields control={control} register={register} errors={errors} showDepart />
      )}

      {!tarifFixeSelectionne &&
        fields.map((field, index) => (
          <StopItem
            key={field.id}
            field={field}
            index={index}
            control={control}
            register={register}
            errors={errors}
            fieldsCount={fields.length}
            addEscale={addEscale}
            removeEscale={removeEscale}
            openFavoriteDrawer={openFavoriteDrawer}
            openAddressSearch={openAddressSearch}
            getLabelAndIconFromOrdre={getLabelAndIconFromOrdre}
            isEscale={isEscale}
            dateCourse={dateCourse}
            trajetretour={trajetretour}
            dateTrajetRetour={dateTrajetRetour}
            favorites={favorites}
          />
        ))}
      <div className="mt-4 flex flex-col sm:flex-row justify-end gap-4 items-center pt-4">
        <Button type="button" onClick={onNext} icon="arrow_forward" className="w-full sm:w-auto">
          {t('continue_to_options')}
        </Button>
      </div>
    </Section>
  )
}
